import { supabase } from '@/integrations/supabase/client';
import type { CampaignExpense } from '../types/campaign.types';

export const campaignExpensesRepository = {
  async getExpenses(campaignId: string, orgId?: string): Promise<CampaignExpense[]> {
    if (orgId) {
      await supabase.rpc('set_current_organization', { org_id: orgId });
    }

    let query = supabase
      .from('campaign_expenses')
      .select('*')
      .eq('campaign_id', campaignId)
      .order('date', { ascending: false });

    if (orgId) {
      query = query.eq('organization_id', orgId);
    }

    const { data, error } = await query;
    if (error) {
      console.error('Error fetching campaign expenses:', error);
      throw error;
    }

    return (data || []) as CampaignExpense[];
  },

  async addExpense(
    expense: Omit<CampaignExpense, 'id' | 'created_at' | 'updated_at'>,
    orgId?: string
  ) {
    if (orgId) {
      await supabase.rpc('set_current_organization', { org_id: orgId });
    }

    const { data, error } = await supabase
      .from('campaign_expenses')
      .insert([expense])
      .select()
      .single();

    if (error) {
      console.error('Error adding campaign expense:', error);
      throw error;
    }

    return data as CampaignExpense;
  },

  async deleteExpense(expenseId: string, orgId?: string) {
    if (orgId) {
      await supabase.rpc('set_current_organization', { org_id: orgId });
    }

    let query = supabase
      .from('campaign_expenses')
      .delete()
      .eq('id', expenseId);

    if (orgId) {
      query = query.eq('organization_id', orgId);
    }

    const { error } = await query;
    if (error) {
      console.error('Error deleting campaign expense:', error);
      throw error;
    }
  },
};
